<template>
  <div>
    <nav class="flex-row">
      <div class="menu-container flex-row">
        <svg-icon
          iconClass="nav-menu"
          @click.native.prevent="handleToggle"
          class="hamburger"
          :class="{'is-active': isActive}"/>
        <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
          <transition-group name="breadcrumb">
            <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if="item.meta.title">
              <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{item.meta.title}}</span>
              <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>
            </el-breadcrumb-item>
          </transition-group>
        </el-breadcrumb>
      </div>
      <el-dropdown class="avatar-container flex-col" size="small">
        <div class="avatar-wrapper">
          <svg-icon iconClass="user"/>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span style="display:block;" @click="dialogVisible =  true">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>

      </el-dropdown>
    </nav>
    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="40%">
      <el-form :model="passwordParams" ref="adminForm" label-width="150px" size="small">
        <el-form-item label="帐号：">
          <el-input v-model="passwordParams.username" style="width: 250px" disabled></el-input>
        </el-form-item>
        <el-form-item label="原密码：">
          <el-input v-model="passwordParams.oldPassword"
                    type="password"
                    style="width: 250px"
                    clearable show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码：">
          <el-input v-model="passwordParams.newPassword"
                    type="password"
                    style="width: 250px"
                    clearable show-password></el-input>
          <p style="font-size: 12px; line-height: 2; color: #9E9E9E; margin: 0">再次输入以确认</p>
          <el-input v-model="confirmPassword"
                    type="password"
                    style="width: 250px"
                    clearable show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogConfirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {updatePassword} from "../../../api/admin";
import {mapGetters} from "vuex";

const defaultPasswordParams = {
  username: null,
  oldPassword: null,
  newPassword: null
}

export default {
  name: "AppNavbar",

  mounted() {
    this.getBreadcrumb()
    this.passwordParams.username = this.name;
  },

  data() {
    return {
      isActive: true,
      levelList: null,
      dialogVisible: false,
      passwordParams: Object.assign({}, defaultPasswordParams),
      confirmPassword: null
    }
  },

  computed: {
    ...mapGetters([
      'name'
    ])
  },

  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },

  methods: {
    handleToggle() {
      this.isActive = !this.isActive;
    },

    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
      const first = matched[0]
      if (first && first.name !== 'home') {
        matched = [{ path: '/home', meta: { title: '首页' }}].concat(matched)
      }
      this.levelList = matched
    },

    handleDialogConfirm() {
      if (this.passwordParams.newPassword !== this.confirmPassword) {
        this.$message({
          message: '两次密码不一致',
          type: 'warning'
        });
        return;
      }
      this.$confirm('是否要修改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updatePassword(this.passwordParams).then(() => {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.logout();
        });
      });
    },

    logout() {
      this.$store.dispatch('FedLogout').then(() => {
        location.reload();
      })
    }
  }
}
</script>

<style lang="scss" scoped>

nav {
  position: fixed;
  z-index: 999;
  justify-content: space-between;
  align-items: center;
  width: calc(100vw - 200px);
  height: 60px;
  padding: 0 16px;
  background-color: rgba(0,0,0, .6);

  .menu-container {
    align-items: center;
    .hamburger {
      cursor: pointer;
      transform: rotate(90deg);
      transition: .38s;
      transform-origin: 50% 50%;
    }

    .is-active {
      transform: rotate(0deg);
    }

    svg {
      font-size: 18px;
      color: #fff;
    }

    .app-breadcrumb {
      font-size: 14px;
      margin-left: 10px;

      .no-redirect {
        color: #fff;
        cursor: text;
      }
    }
  }

  .avatar-container {
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #444;

    svg {
      color: #fff;
    }

    i {
      color: #fff;
    }
  }

  .router-link {
    color: #fff;
  }

  .router-link-exact-active {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppNavbar.vue